import { Button } from "@mui/material";

const ButtonAddyPurple = function ({
    height = "15px",
    width = "15px",
    text = "Placeholder",
    icon = "",
    iconHeight = "15px",
    iconWidth = "15px",
    onClickFunction = () => {},
    disabled = false,
    textColor = "white",
    className = "",
    children = <></>,
}) {
    return (
        <Button
            disabled={disabled}
            className={`h-[${height}] w-[${width}]` + " " + className}
            startIcon={
                icon !== "" ? (
                    <img
                        src={icon}
                        className="contrast-[1000%]"
                        height={iconHeight}
                        width={iconWidth}
                    />
                ) : (
                    <></>
                )
            }
            onClick={onClickFunction}
            variant="contained"
            sx={{
                textTransform: "none",
                color: textColor,
                fontSize: "14",
                background: "#a388f3",
                borderRadius: "8px",
                boxShadow: "none !important",
                "&:active": { background: "#a388f3" },
                "&:visited": { background: "#a388f3" },
                "&:hover": {
                    background: "#7150e0",
                    boxShadow: "none !important",
                },
                "&:focus": { background: "#a388f3",
                    boxShadow: "none !important",
                },
                height: height,
                width: width,
            }}
        >
            {text !== "Placeholder" ? text : children}
        </Button>
    );
};

export { ButtonAddyPurple };
